import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({
  dark: false,
  toggle: () => {},
  cursorStyle: "fin",
  setCursorStyle: () => {},
});

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return false;
    const saved = localStorage.getItem("sb-theme");
    if (saved) return saved === "dark";
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  const [cursorStyle, setCursorStyleState] = useState(() => {
    if (typeof window === "undefined") return "fin";
    return localStorage.getItem("sb-cursor") || "fin";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("sb-theme", dark ? "dark" : "light");
  }, [dark]);

  const setCursorStyle = (style) => {
    setCursorStyleState(style);
    localStorage.setItem("sb-cursor", style);
  };

  return (
    <ThemeContext.Provider
      value={{
        dark,
        toggle: () => setDark((d) => !d),
        cursorStyle,
        setCursorStyle,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
